import { useQuery } from '@tanstack/react-query';
import { RQAPICallWithData } from 'store/APIClient';
import { SupportUserT } from '../../../models';

export const useGetSupportUsers = (bind: string | undefined) =>
    useQuery({
        queryKey: ['support-users', bind],

        queryFn: async () => {
            const response = await RQAPICallWithData<SupportUserT[]>({
                endpoint: `support/${bind}/users`,
                method: 'GET',
            });
            return response.content.data;
        },

        enabled: !!bind,
    });
